import { TransactionStatus } from '@/schemas/transaction_status.schema'
import { useTranslation } from 'react-i18next'
import Badge, { ColorType } from './Badge'

interface Props {
  value: TransactionStatus
}

const STATUS_TRANSLATION_KEYS: Record<TransactionStatus, string> = {
  Approved: 'transaction_status.approved',
  Declined: 'transaction_status.declined',
  'In review': 'transaction_status.in_review',
  'Refunded by Provider': 'transaction_status.refunded_by_provider',
  'Partially Refunded by Provider':
    'transaction_status.partially_refunded_by_provider',
  'Partial Refund in Progress': 'transaction_status.partial_refund_in_progress',
  Unknown: 'transaction_status.unknown',
}

function getColor(value: TransactionStatus): ColorType {
  switch (value) {
    case 'Approved':
      return 'Positive'
    case 'In review':
    case 'Partially Refunded by Provider':
    case 'Partial Refund in Progress':
      return 'Notice'
    case 'Declined':
    case 'Refunded by Provider':
      return 'Negative'
    default:
      return 'Neutral'
  }
}

export default function TransactionStatusBadge({ value }: Props) {
  const { t } = useTranslation()

  return (
    <Badge semanticColor={getColor(value)}>
      {t(STATUS_TRANSLATION_KEYS[value], { defaultValue: value })}
    </Badge>
  )
}
